import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@orderna/admin-panel/src/environments/environment';
import { firstValueFrom, Observable } from 'rxjs';
import { IUser } from '../../model/user';
import {
  UserProfileUpdatePasswordData,
} from '../../model/user-profile';
import {
  toUserProfileUpdatePasswordDtoMapper,
} from '../mapper/user-profile.mapper';
import { IUserProfilesApiService } from './user-profiles-api.interface';
import { AuthApiService } from '../../core/auth/auth-api.service';
import { SuccessResponse } from '../shared/success-response';
import { FindProfileResponseDto } from './dtos/find-profile.response.dto';
import { UpdateProfileResponseDto } from './dtos/update-profile.response.dto';
import { UpdateProfileRequestDto } from './dtos/update-profile.request.dto';

let API_URL = `${environment.api}/users`;

@Injectable({
  providedIn: 'root',
})
export class UserProfilesApiService implements IUserProfilesApiService {
  private http = inject(HttpClient);
  private authService = inject(AuthApiService);

  async findProfile(userId: number): Promise<FindProfileResponseDto> {
    const response = await firstValueFrom(
      this.http.get<SuccessResponse<FindProfileResponseDto>>(
        `${API_URL}/${userId}/settings/profile`
      )
    );

    return response.data;
  }

  async updateProfile(
    userId: number,
    dto: UpdateProfileRequestDto
  ): Promise<UpdateProfileResponseDto> {
    const response = await firstValueFrom(
      this.http.patch<SuccessResponse<UpdateProfileResponseDto>>(
        `${API_URL}/${userId}/settings/profile`,
        dto
      )
    );

    await firstValueFrom(this.authService.getNewAccessToken());

    return response.data;
  }

  updateUserProfilePassword(
    userId: IUser['id'],
    password: UserProfileUpdatePasswordData
  ): Observable<any> {
    const mappedData = toUserProfileUpdatePasswordDtoMapper(password);
    return this.http.patch(
      `${API_URL}/${userId}/settings/profile/password`,
      mappedData
    );
  }
}
